import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Tiktok32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
  >
    <g>
      <path d="M 28 13.121094 C 25.25 13.125 22.5625 12.269531 20.328125 10.667969 L 20.328125 21.835938 C 20.324219 26.074219 17.695312 29.863281 13.726562 31.347656 C 9.757812 32.832031 5.285156 31.699219 2.503906 28.503906 C -0.277344 25.308594 -0.785156 20.722656 1.234375 16.996094 C 3.25 13.269531 7.367188 11.1875 11.5625 11.769531 L 11.5625 17.386719 C 9.640625 16.78125 7.542969 17.480469 6.371094 19.121094 C 5.195312 20.761719 5.210938 22.96875 6.402344 24.59375 C 7.597656 26.222656 9.699219 26.894531 11.613281 26.269531 C 13.53125 25.640625 14.828125 23.851562 14.828125 21.835938 L 14.828125 0 L 20.328125 0 C 20.324219 0.464844 20.363281 0.929688 20.441406 1.386719 C 20.828125 3.449219 22.046875 5.261719 23.8125 6.398438 C 25.054688 7.21875 26.511719 7.660156 28 7.65625 Z M 28 13.121094 " />
    </g>
  </svg>
);

export default Tiktok32;
